import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as PDFObject from 'pdfobject';

@Component({
  selector: 'app-pdf-viewer-modal',
  standalone: true,
  imports: [],
  templateUrl: './pdf-viewer-modal.component.html',
  styles: `
    .pdfobject-container {
      height: 85vh;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfViewerModalComponent implements OnInit {
  readonly activeModal = inject(NgbActiveModal);

  @Input() src!: string;

  ngOnInit() {
    if (!this.src) {
      return;
    }

    const url = this.isUrl(this.src) ? this.src : this.b64toBlobUrl(this.src, 'application/pdf');

    PDFObject.embed(url, '#pdf-container');
    //PDFObject.embed(`data:application/pdf;base64,${this.src}`, '#pdf-container');
  }

  isUrl(str: string): boolean {
    try {
      new URL(str);
      return true;
    } catch {
      return false;
    }
  }

  b64toBlobUrl(b64Data: string, contentType = '', sliceSize = 512): string {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = [...slice].map((char) => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return URL.createObjectURL(blob);
  }
}
